export enum EditCardNameStage {
  EditCardName = 'EditCardName',
}

export interface EditCardNameState {
  stage: EditCardNameStage.EditCardName
  cardId: string
  name: string
}
